import HttpService from "@/utils/httpData"

export const saveLessonQuestionClassSchool = params => {
    let apiEndpoint = `LessonQuestionClassSchool/Create`;
    return HttpService.post(apiEndpoint, params,{
        headers: { 'Content-Type': 'multipart/form-data' }
    }).then(res => {
        return res.data ? res.data : null;
    }).catch(e => { return false });
}
export const listLessonQuestionClassSchool = params => {
    let apiEndpoint = `LessonQuestionClassSchool/List`;
    return HttpService.post(apiEndpoint, params).then(res => {
        return res.data ? res.data : null;
    }).catch(e => { return false });
}
export const getDetail = params => {
    let apiEndpoint = `LessonQuestionClassSchool/detail`;
    return HttpService.post(apiEndpoint,params).then(res => {
        return res.data ? res.data : null;
    }).catch(e => { return false });
}
export const deleteLessonQuestionClassSchool = id => {
    let apiEndpoint = `LessonQuestionClassSchool/Delete?id=${id}`;
    return HttpService.get(apiEndpoint).then(res => {
        return res.data ? res.data : null;
    }).catch(e => { return false });
}

export const getQuestionByDoc = params => {
    let apiEndpoint = `LessonQuestionClassSchool/GetQuestionByDoc`;
    return HttpService.post(apiEndpoint,params).then(res => {
        return res.data ? res.data : null;
    }).catch(e => { return false });
}